module.exports = "canvas {\n    width:100%;\n    /* height: 100%; */\n}\n.canvas-container {\n    width: 100%;\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/speedometer/speedometer.component.css
// module id = ./src/app/modules/shared/components/speedometer/speedometer.component.css
// module chunks = main